// import { Toast } from 'vant';
// import http from '@/services/http';
const isDev = process.env.NODE_ENV === "debug";
const token = localStorage.getItem("token")
import { renderer } from "@cloudpivot/form";
// function getDownloadInfo(params) {
//   return http({
//     url: '/file/upDownload/getDownloadInfo',
//     method: 'get',
//     params
//   });
// }
/**
 * wangeditor富文本编辑器所有参数配置
 */
// 富文本工具栏配置
export const toolbarConfig = {
  // 隐藏哪些工具栏
  excludeKeys: ['group-video', 'insertImage', 'fullScreen', 'codeBlock', 'code', 'todo'],
  mode: 'default' // or 'simple' //simple 简洁模式
};
// 富文本配置
export function editorConfig() {
  return {
    placeholder: '请输入内容...',
    scroll: false,
    hoverbarKeys: {
      image: {
        // 清空 image 元素的 hoverbar
        menuKeys: []
      }
    },
    // maxLength: 100000,
    // 所有的菜单配置，都要在 MENU_CONF 属性下
    MENU_CONF: {
      // 上传图片
      uploadImage: {
        server:isDev ? `/api/aliyun/upload` : `/api/api/aliyun/upload`,
        fieldName: 'file',
        // 单个文件的最大体积限制，默认为 10M
        maxFileSize: 10 * 1024 * 1024, // 10M
        headers: {
          Authorization: `Bearer ${token}`,
        },
        customInsert(res, insertFn) {
          if (res.errcode === 0) {
            console.log('res',res)
            const fileData = res.data
            let fileUrl = ''
            // 没有携带url需要特殊处理
            if (!fileData.url && fileData.refId && fileData.mimeType) {
              fileUrl = renderer.UploadControl.service.getDownloadUrl(fileData);
              console.log('fileUrl',fileUrl)
                if (fileUrl) {
                  insertFn(fileUrl.replace(/^http:/, 'https:'));
                } else {
                  this.$message.error(res.resultMsg || '请求失败');
                }
            }
          } else {
            // Toast(res.resultMsg || '请求失败');
            this.$message.error(res.resultMsg || '请求失败');
          }
        },
        onError(file, err, res) {
          // 单个文件的最大体积限制，默认为 10M
          if (file.size > 10 * 1024 * 1024) {
            // Toast('单个文件限制为10M');
            this.$message.error('单个文件限制为10M');

          }
        }
      },
      // 插入超链接
      insertLink: {
        checkLink(text, url) {
          if (url.indexOf('http') !== 0) {
            // Toast('链接必须以 http/https 开头');
            this.$message.error('链接必须以 http/https 开头');
            return '';
          }
          return true;
        }
      }
    },
    // 所有扩展配置，都要在 EXTEND_CONF 属性下
    EXTEND_CONF: {}
  };
}
